
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";

import AppNavbarSecondary1 from "@/components/layout/AppNavbarSecondary1.vue";
import AppNavbarSecondary2 from "@/components/layout/AppNavbarSecondary2.vue";
import AppNavbarSecondary4 from "@/components/layout/AppNavbarSecondary4.vue";

@Component({
  components: {
    AppNavbarSecondary4,
    AppNavbarSecondary2,
    AppNavbarSecondary1,
  },
})
export default class AppNavbarSecondary extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: 1 })
  private templateNumber!: number;

  private mobileMenu = false;

  private created() {
    $(document).ready(function () {
      $(window).scroll(function () {
        let scroll = $(window).scrollTop() as number;
        if (scroll >= 30) {
          $(".nav-container").addClass("bg-white");
          $("#nav-brand-name").removeClass("text-white");
          $(".burger").addClass("text-black");
          $(".burger").removeClass("text-white");
        } else {
          $(".nav-container").removeClass("bg-white");
          $("#nav-brand-name").addClass("text-white");
          $(".burger").addClass("text-white");
          $(".burger").removeClass("text-black");
        }
      });
    });
  }

  private goHome() {
    if (this.$route.name !== "landing") this.$router.push({ name: "landing" });
  }

  private onNavigateJobFair(e: any) {
    e.preventDefault();
    let baseURL = window.location.href;
    if (baseURL.slice(-1) === "/") baseURL = baseURL.slice(0, -1);
    if (baseURL.includes("?")) baseURL = baseURL.split("?")[0];
    window.open(baseURL + "/jobfair");
  }

  private onClick(route: any) {
    if (route === "candidate-register") {
      this.$router.push({ name: "register" });
    } else if (route === "candidate") {
      this.$store.state.app_login = "candidate";
    } else if (route === "company-register") {
      this.$router.push({ name: "partnership" });
    } else if (route === "company") {
      this.$store.state.app_login = "company";
    } else {
      this.$store.state.app_login = "school";
    }
    this.mobileMenu = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private onMoreNews() {
    this.$router.push({
      name: "news",
    });
  }
}
